import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'react-jss'
import { useDispatch, useSelector } from 'react-redux'

import Button from '../../../components/Button'
import Icon from '../../../components/Icon'
import Loader from '../../../components/Loaders/Loader'
import { ReactComponent as PdfFileIcon } from '../../../assets/icons/pdf-file.svg'

import generatePdfReport from './generatePdfReport'
import { cleanUpTemporaryPDFElements } from '../../../helpers/pdf'

import { getAppDomainName } from '../../helpers/getAppDomainName'

import { setPdfGeneration } from '../../../modules/actions/app'

import { pdfGenerationSelector } from '../../../modules/selectors/app'

import useStyles from './styles'

const PdfGeneration = ({
  dateRangeLabel,
  title,
  getReportPDFSections,
  fileName,
  buttonText = 'Download PDF',
  icon = <PdfFileIcon />
}) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const isPdfGenerating = useSelector(pdfGenerationSelector)
  const appName = getAppDomainName()

  const theme = useTheme()
  const brandColor = theme.brandPrimary

  const handlePdfReportGeneration = async () => {
    dispatch(setPdfGeneration(true))

    const contentSections = await getReportPDFSections(brandColor)

    generatePdfReport({ dateRangeLabel, title, contentSections, fileName, appName })
      .then(() => {
        dispatch(setPdfGeneration(false))
      })
      .catch(() => {
        cleanUpTemporaryPDFElements()
        dispatch(setPdfGeneration(false))
      })
  }

  return (
    <Button className={classes.pdfGenerateBtn} onClick={handlePdfReportGeneration}>
      <Icon className={classes.icon}>{isPdfGenerating ? <Loader /> : icon}</Icon>

      <span>{buttonText}</span>
    </Button>
  )
}

PdfGeneration.propTypes = {
  dateRangeLabel: PropTypes.string,
  title: PropTypes.string,
  getReportPDFSections: PropTypes.func.isRequired,
  fileName: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  icon: PropTypes.node
}

export default PdfGeneration
